import React from 'react';
import ObservationCard from './ObservationCard';
import {useState, useEffect} from 'react';
import {Buffer} from 'buffer';
import { Rings } from 'react-loader-spinner'


function ObservationTable() {

  const [observations, setObservation] = useState([]);
  const CUSTOMER_API_URL = process.env.REACT_APP_CUSTOMER_API_ENDPOINT
  const user = process.env.REACT_APP_USER
  const pass = process.env.REACT_APP_PASS
  const base64encodedData = Buffer.from(`${user}:${pass}`).toString('base64');
  
  const searchObservation = async(name) => {
    const response = await fetch(`${CUSTOMER_API_URL}/customer_learn/observations/?search=${name}`, {
      method: 'GET',
      headers: {'Content-Type': 'application/json','Authorization': 'Basic ' + base64encodedData}})
    const data = await response.json();
    setObservation(data);
  }
  
  useEffect(() => {
    searchObservation('');
  }, [])
    return (
    <div className="container-fluid py-4">
      <div className="row">
        <div className="col-12">
          <div className="card my-4">
            <div className="card-header p-0 position-relative mt-n4 mx-3 z-index-2">
              <div className="bg-gradient-primary shadow-primary border-radius-lg pt-4 pb-3">
                <h6 className="text-white text-capitalize ps-3">Observation table</h6>
              </div>
            </div>
            <div className="card-body px-0 pb-2">
              <div className="table-responsive p-0">

                  {observations?.length > 0 ?
                    (
                      <table className="table align-items-center mb-0">
                      <thead>
                        <tr>
                          <th className="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Observation</th>
                          <th className="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2">Observation Date</th>
                          <th className="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2">Last Activity</th>
                          <th className="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Frequency</th>
                          <th className="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">ID</th>
                          <th className="text-secondary opacity-7"></th>
                        </tr>
                      </thead>
                      <tbody>
                  
                      {observations.map ((observation) => (
                        <ObservationCard key={observation.id} observation={observation}/>
                      ))}
                      </tbody>
                      </table>
                    ) : (
                      <table className="table align-items-center mb-0">
                      <tbody><tr><td>
                      <Rings
                        visible={true}
                        height="80"
                        width="80"
                        color="#4fa94d"
                        ariaLabel="rings-loading"
                        wrapperStyle={{}}
                        wrapperclassName=""
                        />
                      </td></tr></tbody>
                      </table>
                    )
                  }

              </div>
            </div>
          </div>
        </div>
      </div>
    </div> 
    )
}

export default ObservationTable;